import { useTranslation } from 'react-i18next';
import { useSuiteLoungeFlow } from '@/hooks/useSuiteLoungeFlow';

export const ServiceDescription = () => {
  const { t } = useTranslation();
  const { isSuiteLoungeFlow } = useSuiteLoungeFlow();

  return (
    <section className="l-card">
      <h2 className="l-card__title">{t('login.serviceDescription.title')}</h2>
      <div className="l-card__body">
        <ul className="l-list">
          <li className="l-list__item l-list__item--indent l-list__item--white">
            {t('login.serviceDescription.about1')}
          </li>
          <li className="l-list__item l-list__item--indent l-list__item--white">
            {t('login.serviceDescription.about2')}
          </li>
        </ul>

        {/* 予約可能期間 */}
        <div className="l-text-group l-text-group--white">
          <p className="l-text">
            <strong>
              {t('login.serviceDescription.reservationPeriod.title')}
            </strong>
            <br />
            {t('login.serviceDescription.reservationPeriod.shower')}
            {isSuiteLoungeFlow && (
              <>
                <br />
                {t('login.serviceDescription.reservationPeriod.booth')}
              </>
            )}
          </p>
        </div>

        {/* シャワールーム */}
        <div className="l-box l-box--shower">
          <div className="l-box__media">
            <img src="/A_1_Shower.png" alt={t('common.altText.showerRoom')} />
          </div>
          <div className="l-box__content">
            <div className="l-def">
              <div className="l-def__term">
                {t('login.serviceDescription.shower.equipment.title')}
              </div>
              <div className="l-def__desc">
                {t('login.serviceDescription.shower.equipment.description')}
              </div>
            </div>
            <div className="l-def">
              <div className="l-def__term">
                {t('login.serviceDescription.shower.notes.title')}
              </div>
              <div className="l-def__desc">
                <ul className="l-list">
                  <li className="l-list__item l-list__item--indent l-list__item--blue">
                    {t('login.serviceDescription.shower.notes.note1')}
                  </li>
                  <li className="l-list__item l-list__item--indent l-list__item--blue">
                    {t('login.serviceDescription.shower.notes.note2')}
                  </li>
                  <li className="l-list__item l-list__item--indent l-list__item--blue">
                    {t('login.serviceDescription.shower.notes.note3')}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* 防音個室ブース */}
        {isSuiteLoungeFlow && (
          <div className="l-box l-box--booth">
            <div className="l-box__media">
              <img src="/A_1_Booth.png" alt={t('common.altText.privateRoom')} />
            </div>
            <div className="l-box__content">
              <div className="l-def">
                <div className="l-def__term">
                  {t('login.serviceDescription.booth.equipment.title')}
                </div>
                <div className="l-def__desc">
                  {t('login.serviceDescription.booth.equipment.description')}
                </div>
              </div>
              <div className="l-def">
                <div className="l-def__term">
                  {t('login.serviceDescription.booth.notes.title')}
                </div>
                <div className="l-def__desc">
                  <ul className="l-list">
                    <li className="l-list__item l-list__item--indent l-list__item--blue">
                      {t('login.serviceDescription.booth.notes.note1')}
                    </li>
                    <li className="l-list__item l-list__item--indent l-list__item--blue">
                      {t('login.serviceDescription.booth.notes.note2')}
                    </li>
                    <li className="l-list__item l-list__item--indent l-list__item--blue">
                      {t('login.serviceDescription.booth.notes.note3')}
                    </li>
                    <li className="l-list__item l-list__item--indent l-list__item--blue">
                      {t('login.serviceDescription.booth.notes.note4')}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </section>
  );
};
